import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { Form, Button, Container } from "react-bootstrap";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Icon } from "@cdk-uip/react-icon";

import api from "../../api/candidate.resource";
import { defaultToastOptions } from "../../constants/constants";
import CDK_GLOBAL_CIRCULAR_LOGO from "../../images/CDK-Circular-Logo.png";
import FORGOT_PASSWORD from "../../images/Forgot-Password.svg";
import useValidation from "../../util/useValidation";

export const ForgotPassword = ({ history }) => {
  const [userNameorEmail, setuserNameorEmail] = useState("");
  const [forgotPasswordError, setForgotPasswordError] = useState();
  const { handleOnBlurValidation, errors } = useValidation();
  const handleOnChangeInput = ({ target: { value } }) => {
    setuserNameorEmail(value);
    setForgotPasswordError("");
  };

  const handOnBlurInput = e => {
    handleOnBlurValidation(e);
  };

  const handleOnClickForgotPassword = async e => {
    try {
      e.preventDefault();
      toast.configure();
      const res = await api.forgotPassword({ userNameorEmail });
      if (res) {
        if (res.errorMessage) {
          setForgotPasswordError(res.errorMessage);
        } else {
          toast.success(
            "New Password has been sent to your Email Id",
            defaultToastOptions
          );
          history.push("/");
        }
      }
    } catch (e) {
      toast.error("Error while Resetting Password", defaultToastOptions);
    }
  };

  return (
    <Container className="login-pages-container">
      <img
        className="forgot-password-img"
        src={FORGOT_PASSWORD}
        alt="ForgotPasswordImg"
      />

      <div className="login-controls-container">
        <NavLink className="back-to-login-nav" exact={true} to="/" activeClassName="link">
          <Icon
            className="font-weight-bold"
            onClick={() => {}}
          >
            arrow_back
          </Icon>
        </NavLink>
        <div className="login-controls">
          <img
            className="cdk-circular-logo"
            src={CDK_GLOBAL_CIRCULAR_LOGO}
            alt="CDKGlobalCircularLogo"
          />
          <h4 className="font-weight-bold">Forgot Password</h4>
          <Form noValidate onSubmit={handleOnClickForgotPassword}>
            <div className="login">
              <Form.Control
                size="lg"
                type="text"
                id="userNameorEmail"
                className="input"
                name="userNameorEmail"
                value={userNameorEmail}
                placeholder="Username or Email Id"
                onChange={handleOnChangeInput}
                required
                onBlur={handOnBlurInput}
                isInvalid={errors.userNameorEmail}
              />
              {errors.userNameorEmail && (
                <Form.Control.Feedback type="invalid">
                  {errors.userNameorEmail.type === "required" &&
                    "Please enter your username or email id"}
                </Form.Control.Feedback>
              )}

              {!!forgotPasswordError && (
                <div className="error">{forgotPasswordError}</div>
              )}

              <Button
                variant=""
                size="lg"
                className="onLogin text-nowrap"
                disabled={!userNameorEmail}
                onClick={handleOnClickForgotPassword}
              >
                Forgot Password
              </Button>
            </div>
          </Form>
          <div className="formFooter">
            <NavLink exact={true} to="/" activeClassName="link">
              Back to login
            </NavLink>
          </div>
        </div>
      </div>
    </Container>
  );
};
export default ForgotPassword;
